__webpack_require__.p = "https://student-matching-dashboard.tst.studyportals.eu/dist/";